// extracted by mini-css-extract-plugin
export default {"centeredKeyboard":"GenActionAskOccurrencesView_centeredKeyboard__V0yu6"};